export function validatePhone(phone: string) {
    if(phone === "(___) ___-____") return false
    if(phone.length < 14 ) return false
    if(phone === "(___) ___ ____") return false
    if(phone.trim().length === 0) return false
    return true
}

export function validateEmail(email: string) {
    const exp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return exp.test(email);
}

export function removeSpecialChars(str: string) {
    return str ? str.replace(/[^A-Za-z0-9]/g, '').replace(/\/s/g, '') : '';
}

export function onlyNumbers(string: string) {
    let numsStr = `${string}`.replace(/[^0-9]/g,'');
    if (!numsStr) return ""
    return numsStr;
}

export function returnOnlyNumbersAsInteger(string: string) {
    let numsStr = string.replace(/[^0-9]/g,'');
    if (!numsStr) {
      return 0
    }
    return parseInt(numsStr);
}

export function onlyLetters(string: string) {
    let str = string.replace(/[^A-Za-z]/g,'');
    if (!str) {
      return ""
    }
    return str
}

export function inputTypeNumberValidation(event: React.KeyboardEvent<HTMLInputElement>) {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const regex = /[0-9]|\./;
    if (!regex.test(keyValue)) {
        event.preventDefault();
    }
}

export function onlySpaces(str: string) {
    return str.trim().length === 0;
}

export function removeSpaces(str: string) {
    return str.replace(/ /g,'')
}

export function onlyNumbersAndDots(str: string): boolean {
    let res = str.replace(/\./g,'')
    res = res.replace(/[0-9]/g,'')
    if (res.length === 0) {
        return true
    }
    return false
}
